const DATA_TEST_IDS = {
  authentication: 'profile__security_authentication_authentication',
  authenticationCard: 'profile__security_authentication_card',
  authenticationCards: 'profile__security_authentication_cards',
} as const;

export default DATA_TEST_IDS;
